import React, { useRef } from 'react';
import PhotoDropzone from './PhotoDropzone';
import VideoDropzone from './VideoDropzone';
import '../Button.css';

// The two ways into a bare project, as equal peers. Before this they were a
// large padded panel next to a small dashed box, which read as "the real one
// and the afterthought". Neither tile advertises drag-and-drop — the CTA is
// the file picker, which is the path that actually works.

const VideoIcon = () => (
  <svg
    className="pi-footage-tile-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="2.5" y="6" width="19" height="14" rx="2" />
    <path d="M2.5 10h19" />
    <path d="M6.5 6 8 10" />
    <path d="M11.5 6 13 10" />
    <path d="M16.5 6 18 10" />
    <path d="m10.5 13.2 4 2.3-4 2.3z" />
  </svg>
);

// No `disabled` on the photo tile: this panel only mounts on a bare project,
// which by definition is idle — the moment a scan starts it unmounts.
//
// `onVideoFiles` is the multi-video (multiVideoV1) entry point. When it is
// absent — the flag is off — this panel renders EXACTLY the two tiles it
// always did: the single .mp4 picker and the photo dropzone.
const AddFootagePanel = ({ onFileChange, onPhotoFiles, onVideoFiles }) => {
  const videoInputRef = useRef(null);

  if (onVideoFiles) {
    // Flag on: the video tile accepts a whole shoot, not one clip. Cameras
    // that record for weeks always split the recording across many files, so
    // "one .mp4" is the wrong shape of the question to ask a construction
    // documentarian.
    return (
      <section className="pi-add-footage" aria-label="Add footage" data-testid="add-footage-panel">
        <VideoDropzone variant="tile" onFiles={onVideoFiles} />
        <PhotoDropzone variant="tile" onFiles={onPhotoFiles} />
      </section>
    );
  }

  return (
    <section className="pi-add-footage" aria-label="Add footage" data-testid="add-footage-panel">
      <div className="pi-footage-tile" data-testid="add-footage-video">
        <VideoIcon />
        <b className="pi-footage-tile-title">Upload a video</b>
        <p className="pi-footage-tile-hint">One .mp4 timelapse clip</p>
        <button
          type="button"
          className="btn btn-teal pi-footage-tile-cta"
          onClick={() => videoInputRef.current?.click()}
        >
          Choose video
        </button>
        <input
          ref={videoInputRef}
          type="file"
          accept=".mp4"
          onChange={onFileChange}
          id="video-upload"
          data-testid="video-input"
          style={{ display: 'none' }}
        />
      </div>
      <PhotoDropzone variant="tile" onFiles={onPhotoFiles} />
    </section>
  );
};

export default AddFootagePanel;
